import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

let currentPinnedDiv = null; 

const Message = ({ message, duration = 2000, onClose, type = "error" }) => {
  useEffect(() => {
    // if (type !== "pinned") {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    // }
  }, [duration, onClose, type]);

  return (
    <div onClick={onClose} className={`ui-message ${type} ${type === "pinned" ? "ui-pin" : ""}`}>
      <div>{message}</div>
      {type === "pinned" && (
        <button className="ui-message-close">
          ×
        </button>
      )}
    </div>
  );
};

export const showError = (_obj, duration = 3000, type = "error") => {
  let _message = _obj?.error || "There was an error."; 
  if (_obj?.kwargs?.message) {
    _message = _obj.kwargs.message;
  }

  const div = document.createElement('div');
  document.body.appendChild(div);

  const removeMessage = () => {
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
  };

  ReactDOM.render(
    <Message type={type} message={_message} duration={duration} onClose={removeMessage} />,
    div
  );
};

export const showMessage = (message, duration, type = "message") => {
  const div = document.createElement("div");

  if (type === "pinned" && currentPinnedDiv) {
    ReactDOM.unmountComponentAtNode(currentPinnedDiv);
    document.body.removeChild(currentPinnedDiv);
    currentPinnedDiv = null;
  }

  document.body.appendChild(div);

  const removeMessage = () => {
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
    if (currentPinnedDiv === div) currentPinnedDiv = null;
  };

  ReactDOM.render(
    <Message
      type={type}
      message={message}
      duration={duration}
      onClose={removeMessage}
    />,
    div
  );

  if (type === "pinned") currentPinnedDiv = div;
};

export default Message;
